import {
  Icon,
  IconProps,
  Input,
  InputGroup,
  InputRightElement,
  InputRightElementProps,
} from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { get } from "lodash";
import { useCallback, useState } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";

interface PasswordInputFieldProps {
  name: string;
  inputRightElementProps?: InputRightElementProps;
  inputIconProps?: IconProps;
}

function PasswordInputField({
  name,
  inputRightElementProps,
  inputIconProps,
  ...props
}: PasswordInputFieldProps) {
  const { values } = useFormikContext();
  const [show, setShow] = useState(false);

  const handleClick = useCallback(() => setShow((prev) => !prev), []);
  return (
    <InputGroup size="md">
      <Input
        name={name}
        value={get(values, name, "")}
        autoComplete={show ? "on" : "off"}
        {...props}
        type={show ? "text" : "password"}
      />
      <InputRightElement
        display="flex"
        alignItems="center"
        mt="4px"
        {...inputRightElementProps}
      >
        <Icon
          _hover={{ cursor: "pointer" }}
          as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
          {...inputIconProps}
          onClick={handleClick}
        />
      </InputRightElement>
    </InputGroup>
  );
}

export default PasswordInputField;
